<template>
  <b-container>
    <b-row>
      <b-col>
        <b-container class="mt-3 text-center justify-content-center">
          <b-button
              v-for="colorVersion in colorVersions"
              :key="colorVersion.id"
              @click="onClickColorVersion(colorVersion)"
              class="text-center mr-2"
              style="background-color: unset; color: #1b1b1b; border-radius: 6px; border: 2px #1b1b1b; text-align: center; justify-content: center"
          >
            <div
                v-if="colorVersion.colorName === 'GENERAL'"
                class="ml-1 mr-1"
                style="border-radius: 10px; height: 35px; width: 35px; margin: 3px; display: inline-block">
              <font-awesome-icon
                  :icon="['fa-regular', 'fa-clothes-hanger']"/>
            </div>
            <div>
              <div
                  v-if="colorVersion.colorName !== 'GENERAL' && colorVersion.colorHex !== '0'"
                  class="ml-1 mr-1"
                  :style="'background-color: ' + colorVersion.colorHex + '; border-radius: 10px; border: 2px solid #1b1b1b; height: 35px; width: 35px; margin: 3px; display: inline-block'">
              </div>
            </div>
            <div
                v-if="colorVersion.colorName !== 'GENERAL' && colorVersion.colorHex === '0'"
                class="ml-1 mr-1">
              <font-awesome-icon
                  :icon="['fa-duotone', 'fa-square-xmark']"
                  style="border-radius: 10px; height: 35px; width: 35px; margin: 3px; display: inline-block"/>
            </div>
            {{ colorVersion.colorName }}
          </b-button>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container>
          <div class="mt-3 pr-5"
               style="display: flex; flex-direction: column; justify-content: center; align-items: center">
            <div
                style="width: 500px; height: 500px; position: relative; display: flex; justify-content: center; align-items: center">
              <img
                  v-if="selectedPhoto"
                  :src="selectedPhoto ? selectedPhoto.url : ''"
                  alt="main-photo"
                  style="max-width: 100%; max-height: 100%; object-fit: contain"/>
            </div>
            <div class="mt-2" style="display: flex; justify-content: center; align-items: center; flex-wrap: wrap">
              <div
                  v-if="currentPhotos.length > 0"
                  v-for="(photo, index) in currentPhotos"
                  :key="index"
                  class="thumbnail-wrapper"
                  style="width: 70px; height: 70px; margin: 0 10px; cursor: pointer; transition: transform 0.3s ease; overflow: hidden; display: flex; justify-content: center; align-items: center"
                  @click="selectPhoto(index)">
                <img
                    :src="photo ? photo.url : ''"
                    alt="min-photo"/>
              </div>
            </div>
          </div>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import FormModel from "@/components/forms/FormModel";
import ImageFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/ImageFormFieldConfig";
import Rpc from "@/Rpc";
import rpc from "@/Rpc";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import ColorVersion from "@/server/com/silkplm/model/plm/ColorVersion";

export default {
  name: "PhotoGalleryPreviewRenderer",

  async mounted() {
    this.$onChange(ProductInSeason.getRemoteClass(), async () => {
      if (this.mode !== 'NEW') {
        await this.reloadGallery();
      }
    });

    this.$onChange(ColorVersion.getRemoteClass(), () => {
      this.reloadGallery();
    });

    this.parentForm.onLoaded(async () => {
      await this.reloadGallery();
    });
  },

  methods: {
    selectPhoto(index) {
      this.selectedPhoto = this.currentPhotos[index];
    },

    onClickColorVersion(colorVersion) {
      this.currentColorVersion = colorVersion;
      if (!this.currentColorVersion.gallery) {
        this.currentPhotos = this.productInSeasonGallery.imagesList;
      } else {
        this.currentPhotos = this.currentColorVersion.gallery.imagesList;
      }

      if (this.currentPhotos) {
        let filteredPhotos = this.currentPhotos.filter(element => element.customData?.imageTagList.some(x => x.name === "Main Picture"));
        if (filteredPhotos.length > 0) {
          this.selectedPhoto = filteredPhotos[0];
        } else if (this.currentPhotos.length > 0) {
          // Ustawienie pierwszego zdjęcia jako domyślne, jeśli brak zdjęcia z tagiem "Main Picture"
          this.selectedPhoto = this.currentPhotos[0];
        }
      }
    },

    // async getHex(colorName) {
    //   return await Rpc.plm.services.MarketingService.getHexByName(colorName);
    // },

    async createColorHex(pantoneColor) {
      let colorBackend = await rpc.Pantone.pantoneByName(pantoneColor);
      if (!colorBackend) {
        return '0';
      }
      return colorBackend.hex;
    },

    async reloadGallery() {
      this.colorVersions = [];
      let productInSeasonId = this.validatedField.validatedForm.directParentFormModel.validatedFieldByName('id').value;

      this.productInSeasonGallery = this.validatedField.validatedForm.directParentFormModel.validatedFieldByName('gallery')?.value;
      if (!this.productInSeasonGallery) {
        this.productInSeasonGallery = this.validatedField.validatedForm.validatedFieldByName('productInSeasonIdGallery')?.value;
        if (!this.productInSeasonGallery) {
          this.productInSeasonGallery = [];
          this.currentPhotos = [];
        }
      }
      let productInSeason = {colorName: 'GENERAL', colorHex: '', gallery: this.productInSeasonGallery};
      this.colorVersions.push(productInSeason);

      // Inicjalizacja głównego zdjęcia
      this.onClickColorVersion(productInSeason);

      if (productInSeasonId) {
        let data = await Rpc.plm.services.MarketingService.getColorVersionData(productInSeasonId);
        if (data === null || undefined) {
          return;
        }

        for (const colorVersionWithColorDto of data) {
          let temp = {
            colorName: colorVersionWithColorDto.color.colorName,
            colorHex: await this.createColorHex(colorVersionWithColorDto.colorVersion.pantoneColor),
            gallery: colorVersionWithColorDto.colorVersion.gallery,
          };
          this.colorVersions.push(temp);
        }
      }
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: false},
    fieldConfig: {type: ImageFormFieldConfig, required: false},
    mode: {default: null},
    parentForm: {type: FormModel}
  },

  data: function () {
    return {
      productInSeasonGallery: [],
      currentPhotos: [],
      selectedPhoto: null,
      colorVersions: [],
      currentColorVersion: {}
    }
  }
}
</script>

<style scoped>
.thumbnail-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.thumbnail-wrapper.selected {
  transform: scale(1.1);
}

.thumbnail-wrapper:hover {
  transform: scale(1.1);
}
</style>